// extracted by mini-css-extract-plugin
export default {"container":"Consultations_container__rHwfP","editConsultationContainer":"Consultations_editConsultationContainer__W7ziT","tabsContainer":"Consultations_tabsContainer__1Yw5k"};